export const STOCKIST = {
  name: 'Anand Medical Agency',
  city: 'Ahmedabad',
  role: 'Stockist',
  accountCode: 'AHD-STK-0421',
  phone: '+91 98765 43210',
  email: 'anand.medical@intas.net',
  activeSbu: 'mSBU',
  lastSync: '2 mins ago',
};

export const formatINR = (value) =>
  new Intl.NumberFormat('en-IN').format(Math.round(value));

export const MONTHLY_DATA = [
  { month: 'Oct 2025', sale: 1420000, uploaded: 1210000, pending: 210000, pct: 85, syncLabel: 'Last synced: 4 hrs ago' },
  { month: 'Nov 2025', sale: 1575000, uploaded: 1325000, pending: 250000, pct: 84, syncLabel: 'Last synced: 3 hrs ago' },
  { month: 'Dec 2025', sale: 1640000, uploaded: 1195000, pending: 445000, pct: 73, syncLabel: 'Last synced: 2 hrs ago' },
  { month: 'Jan 2026', sale: 1760000, uploaded: 1340000, pending: 420000, pct: 76, syncLabel: 'Last synced: 1 hr ago' },
  { month: 'Feb 2026', sale: 1810000, uploaded: 1460000, pending: 350000, pct: 81, syncLabel: 'Last synced: 30 mins ago' },
  { month: 'Mar 2026', sale: 1842500, uploaded: 1252750, pending: 589750, pct: 68, syncLabel: 'Current Month Progress' },
];

export const INITIAL_OVERVIEW = {
  thisMonthPurchase: 1842500,
  fyPurchase: 21486000,
};

export const STATUS_CONFIG = {
  PENDING_UPLOAD: { label: 'Pending Upload', className: 'badge-pending' },
  OCR_CONFIRMATION: { label: 'OCR Needs Confirmation', className: 'badge-ocr' },
  UNDER_REVIEW: { label: 'Under Review', className: 'badge-review' },
  VERIFIED: { label: 'Verified', className: 'badge-verified' },
};

export const INITIAL_INVOICES = [
  { id: 1, date: '21 Mar 2026', invoiceNo: 'INV-GYN-24031', buyer: 'Shreeji Women\'s Hospital', amount: 82450, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 2, date: '22 Mar 2026', invoiceNo: 'INV-GYN-24036', buyer: 'Aastha Women Care Hospital', amount: 124800, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 3, date: '22 Mar 2026', invoiceNo: 'INV-GYN-24039', buyer: 'Krupa Maternity Clinic', amount: 58320, status: 'OCR_CONFIRMATION', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 4, date: '23 Mar 2026', invoiceNo: 'INV-GYN-24044', buyer: 'Lifeline Women\'s Hospital', amount: 156900, status: 'UNDER_REVIEW', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 5, date: '23 Mar 2026', invoiceNo: 'INV-GYN-24047', buyer: 'Maa Gynae & Maternity', amount: 92650, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 6, date: '24 Mar 2026', invoiceNo: 'INV-GYN-24052', buyer: 'Om Sai Women\'s Hospital', amount: 73200, status: 'VERIFIED', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 7, date: '24 Mar 2026', invoiceNo: 'INV-GYN-24053', buyer: 'HealthFirst Maternity Centre', amount: 68950, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 8, date: '24 Mar 2026', invoiceNo: 'INV-GYN-24055', buyer: 'Nisha Maternity Hospital', amount: 49600, status: 'OCR_CONFIRMATION', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 9, date: '25 Mar 2026', invoiceNo: 'INV-GYN-24058', buyer: 'CarePlus Women\'s Clinic', amount: 112400, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 10, date: '25 Mar 2026', invoiceNo: 'INV-GYN-24061', buyer: 'WellCare Hospital', amount: 86700, status: 'UNDER_REVIEW', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 11, date: '25 Mar 2026', invoiceNo: 'INV-GYN-24063', buyer: 'Sanjivani Women\'s Care', amount: 54250, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
  { id: 12, date: '25 Mar 2026', invoiceNo: 'INV-GYN-24066', buyer: 'Prime Women\'s Hospital', amount: 129530, status: 'PENDING_UPLOAD', month: 'Mar 2026', sbu: 'Gynaecology' },
];

export const CATEGORIES = [
  { id: 1, name: 'Fertility', color: '#E91E63', bgColor: '#FCE4EC' },
  { id: 2, name: "Women's Wellness", color: '#9C27B0', bgColor: '#F3E5F5' },
  { id: 3, name: 'Hormonal Support', color: '#3F51B5', bgColor: '#E8EAF6' },
  { id: 4, name: 'Gynae Hematinics', color: '#F44336', bgColor: '#FFEBEE' },
  { id: 5, name: 'Bone & Supportive', color: '#4CAF50', bgColor: '#E8F5E9' },
  { id: 6, name: 'Injectable Range', color: '#FF5722', bgColor: '#FBE9E7' },
  { id: 7, name: 'Miscellaneous', color: '#607D8B', bgColor: '#ECEFF1' },
  { id: 8, name: 'Top Movers', color: '#FF9800', bgColor: '#FFF3E0' },
];

export const PRODUCTS = [
  { id: 1, name: 'Femiron XT', segment: 'Gynae Hematinics', pack: 'Tab 30s', mrp: 285, status: 'Frequently Invoiced', invoiceCount: 8, description: 'Iron + Folic Acid + B12 for women\'s haematinic support', category: 'Gynae Hematinics', sbu: 'Gynaecology' },
  { id: 2, name: 'Femiron DHA', segment: 'Gynae Hematinics', pack: 'Soft Gel 30s', mrp: 320, status: 'Active', invoiceCount: 5, description: 'Iron + DHA + B12 formulation for maternal health', category: 'Gynae Hematinics', sbu: 'Gynaecology' },
  { id: 3, name: 'Gynafol Plus', segment: "Women's Wellness", pack: 'Tab 30s', mrp: 180, status: 'Active', invoiceCount: 6, description: 'Folic acid + B-vitamins for pre-conception care', category: "Women's Wellness", sbu: 'Gynaecology' },
  { id: 4, name: 'Gynafol XT', segment: "Women's Wellness", pack: 'Tab 60s', mrp: 245, status: 'Frequently Invoiced', invoiceCount: 9, description: 'Extended folate + micronutrients for prenatal health', category: "Women's Wellness", sbu: 'Gynaecology' },
  { id: 5, name: 'Ovulenta 75', segment: 'Fertility', pack: 'Vial 75 IU', mrp: 4250, status: 'Frequently Invoiced', invoiceCount: 7, description: 'FSH 75 IU for ovulation induction', category: 'Fertility', sbu: 'Fertility/IVF' },
  { id: 6, name: 'Ovulenta 150', segment: 'Fertility', pack: 'Vial 150 IU', mrp: 7850, status: 'Active', invoiceCount: 4, description: 'FSH 150 IU for controlled ovarian stimulation', category: 'Fertility', sbu: 'Fertility/IVF' },
  { id: 7, name: 'Ovulenta 300', segment: 'Fertility', pack: 'Vial 300 IU', mrp: 14500, status: 'Low Movement', invoiceCount: 2, description: 'High dose FSH for IVF protocols', category: 'Fertility', sbu: 'Fertility/IVF' },
  { id: 8, name: 'Progesta-M', segment: 'Hormonal Support', pack: 'Cap 200mg 14s', mrp: 395, status: 'Frequently Invoiced', invoiceCount: 10, description: 'Micronized progesterone for luteal phase support', category: 'Hormonal Support', sbu: 'Gynaecology' },
  { id: 9, name: 'CalciSure Women', segment: 'Bone & Supportive', pack: 'Tab 30s', mrp: 195, status: 'Active', invoiceCount: 5, description: 'Calcium + Vitamin D3 + Magnesium for women\'s bone health', category: 'Bone & Supportive', sbu: 'Gynaecology' },
  { id: 10, name: 'Uterafit', segment: "Women's Wellness", pack: 'Tab 30s', mrp: 215, status: 'Recently Uploaded', invoiceCount: 3, description: 'Uterine tonic for functional disorders', category: "Women's Wellness", sbu: 'Gynaecology' },
  { id: 11, name: 'IVF-Gen FSH 75', segment: 'Fertility', pack: 'Vial 75 IU', mrp: 5200, status: 'Active', invoiceCount: 6, description: 'Recombinant FSH 75 IU for IVF stimulation', category: 'Fertility', sbu: 'Fertility/IVF' },
  { id: 12, name: 'IVF-Gen FSH 150', segment: 'Fertility', pack: 'Vial 150 IU', mrp: 9800, status: 'Recently Uploaded', invoiceCount: 4, description: 'Recombinant FSH 150 IU for advanced IVF protocols', category: 'Fertility', sbu: 'Fertility/IVF' },
];

export const OCR_TEMPLATE = {
  lineItems: [
    { product: 'Femiron XT 30s', pack: 'Tab 30s', qty: 50, amount: 41250 },
    { product: 'Gynafol Plus 30s', pack: 'Tab 30s', qty: 30, amount: 25800 },
    { product: 'Progesta-M 200mg', pack: 'Cap 14s', qty: 10, amount: 15400 },
  ],
};

// Initial sales invoices (demo data)
export const INITIAL_SALES_INVOICES = [
  {
    id: 1001,
    invoiceNo: 'SI-2026-0001',
    date: '2026-03-20',
    hospitalName: 'City Women\'s Hospital',
    amount: 125000,
    status: 'APPROVED',
    lineItems: [
      { productName: 'Femiron XT', quantity: 50, amount: 42500 },
      { productName: 'Gynafol Plus', quantity: 40, amount: 32000 },
      { productName: 'Progesta-M', quantity: 30, amount: 50500 },
    ],
    remarks: 'Monthly order',
    createdAt: '2026-03-20T10:30:00Z',
  },
  {
    id: 1002,
    invoiceNo: 'SI-2026-0002',
    date: '2026-03-22',
    hospitalName: 'LifeCare Maternity Centre',
    amount: 87500,
    status: 'UNDER_REVIEW',
    lineItems: [
      { productName: 'Ovulenta 75', quantity: 10, amount: 42500 },
      { productName: 'CalciSure Women', quantity: 60, amount: 11700 },
      { productName: 'Uterafit', quantity: 80, amount: 33300 },
    ],
    remarks: '',
    createdAt: '2026-03-22T14:15:00Z',
  },
  {
    id: 1003,
    invoiceNo: 'SI-2026-0003',
    date: '2026-03-24',
    hospitalName: 'Shreeji Women\'s Hospital',
    amount: 156200,
    status: 'VERIFIED',
    lineItems: [
      { productName: 'IVF-Gen FSH 75', quantity: 15, amount: 78000 },
      { productName: 'Femiron DHA', quantity: 100, amount: 32000 },
      { productName: 'Gynafol XT', quantity: 120, amount: 46200 },
    ],
    remarks: 'IVF supplies order',
    createdAt: '2026-03-24T09:00:00Z',
  },
  {
    id: 1004,
    invoiceNo: 'SI-2026-0004',
    date: '2026-03-25',
    hospitalName: 'Prime Care Hospital',
    amount: 64800,
    status: 'UNDER_REVIEW',
    lineItems: [
      { productName: 'Femiron XT', quantity: 80, amount: 22800 },
      { productName: 'Progesta-M', quantity: 25, amount: 42000 },
    ],
    remarks: 'Regular monthly stock',
    createdAt: '2026-03-25T11:45:00Z',
  },
];
